import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import EnrolementProcess from './components/pages/enrolement/EnrolementProcess';

import {
  ACCOUNT_ALREADY_ACTIVATED,
  ACTIVATION,
  CONTACT_PAGE,
  CGU,
  CHARTE_ETHIQUE,
  CREATION, ENROLEMENT,
  ERROR_LOGIN_PAGE_ROUTE,
  FAQ,
  GP_ACTIVATION,
  MON_ID_NUM,
  PRO_ACTIVATION,
  VERIFICATION_MAIL,
  VERIFICATION_NVX_EMAIL,
} from './routes';
import AccountActivation from './components/pages/accountActivation/AccountActivation';
import SendActivationCodeForm from './components/pages/accountActivation/ContactPage';
import AccountCreation from './components/pages/accountCreation/AccountCreation';
import IntermediaryPage from './components/pages/intermediaryPage/IntermediaryPage';
import ConditionsUtilisation from './components/pages/static/ConditionsUtilisation';
import { updateLinks } from './network/api/links';
import Aide from './components/pages/static/Aide';
import CharteEthique from './components/pages/static/CharteEthique';
import Router from './components/Router';
import sessionApi from './network/api/sessionApi';
import ActivationLinkPage from './components/pages/emailsPages/ActivationLinkPage';
import VerificationMail from './components/pages/emailsPages/VerificationMail';
import AccountAlreadyActivated from './components/pages/emailsPages/AccountAlreadyActivated';
import VerificationModificationEmail from './components/pages/emailsPages/VerificationModificationEmail';
import ErrorPage from './components/pages/error/ErrorPage';

sessionApi.fetchUrl().then((links) => { updateLinks(links); });

function App(): JSX.Element {
  return (
    /* eslint-disable react/jsx-filename-extension */
    <div id="app">
      <ToastContainer />
      <div className="container">
        <div className="content-container">
          <main id="main-content">
            <Switch>
              <Route path={ACTIVATION} component={AccountActivation} />
              <Route path={CREATION} component={AccountCreation} />
              <Route path={CONTACT_PAGE}>
                <SendActivationCodeForm />
              </Route>
              <Route path={MON_ID_NUM} component={IntermediaryPage} />
              <Route path={FAQ} component={Aide} />
              <Route path={CGU} component={ConditionsUtilisation} />
              <Route path={CHARTE_ETHIQUE} component={CharteEthique} />
              <Route path={PRO_ACTIVATION} component={ActivationLinkPage} />
              <Route path={GP_ACTIVATION} component={ActivationLinkPage} />
              <Route exact path={VERIFICATION_MAIL} component={VerificationMail} />
              <Route path={ACCOUNT_ALREADY_ACTIVATED} component={AccountAlreadyActivated} />
              <Route path={VERIFICATION_NVX_EMAIL} component={VerificationModificationEmail} />
              <Route path={ERROR_LOGIN_PAGE_ROUTE} component={ErrorPage} />
              <Route path={ENROLEMENT} component={EnrolementProcess} />
              <Route path="*" component={Router} />
            </Switch>
          </main>
        </div>
      </div>
    </div>
  );
}

export default App;
